import React from 'react';
import AssetTable from '../components/AssetTable';

export default function StocksPage() {
  return <AssetTable type="stock" title="Aktien" icon="fa-solid fa-building-columns" chartType="stock" />;
}
